import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import user from './modules/user'
import location from './modules/location'
import print from './modules/print'
import getters from './getters'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,
    app,
    location,
    print
  },
  getters
})



// WEBPACK FOOTER //
// ./src/store/index.js